import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Autocomplete from "@mui/material/Autocomplete";
import Chip from "@mui/material/Chip";
import { useFormik } from "formik";
import * as yup from "yup";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import Text from "components/common/Text";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { Typography } from "@mui/material";
//dispatch


const validateLoginForm = yup.object().shape({
  category_id: yup.string().required("Category is required"),
  question: yup.string().required("Question is required"),
  answer: yup.string().required("Answer is required"),
});

const AddFaq = (props) => {
  let history = useHistory();
  const {
    loading,
    update,
    is_update,
    category,
    submit,
    data,
    ParentCategoriesList,
    onChangeCategory,
    handleChangeF,
    handleBack
  } = props;

  let pageTypes = [
    {
      name: "Ev Website",
      id: "EVJOINTS_WEBSITE"
    },
    {
      name: "Ev APP",
      id: "EVJOINTS_APP"
    },
    {
      name: "Home Page",
      id: "HOME_PAGE"
    },
    {
      name: "Trip Planner",
      id: "TRIP_PLAN"
    },
  ]

  const [keywords, setKeywords] = useState([]);

  const onSubmit = async (values) => {
    let payload = {
      category_id: values.category_id,
      subcategory_id: values.subcategory_id,
      question: values.question,
      answer: values.answer,
      keywords: keywords,
      content_type:values.content_type,
    };

    if (is_update) {
      update(payload);
    } else {
      submit(payload);
    }
  };

  const formik = useFormik({
    enableReinitialize: true,
    validateOnBlur: true, // validate fields on blur
    validateOnSubmit: true, // validate fields on submit
    initialValues: is_update
      ? data[0]
      : {
          category_id: "",
          subcategory_id: "",
          question: "",
          answer: "",
          keywords: [],
          content_type:"",
        },
    onSubmit: (values) => {
      onSubmit(values);
    },
    validationSchema: validateLoginForm,
  });

  function handleKeyword(value) {
    setKeywords(value);
  }

  React.useEffect(() => {
    onChangeCategory(formik?.values?.category_id);
 
   
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.category_id]);
React.useEffect(() => {
    // onChangeCategory(formik?.values?.category_id);
    handleChangeF(formik?.values?.content_type)
    if(formik?.values?.content_type==='HOME_PAGE')formik.setFieldValue('category_id',161) 
    if(formik?.values?.content_type==='TRIP_PLAN')formik.setFieldValue('category_id',162) 
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik?.values?.content_type])



  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <Text
          variant="h5"
          color="#707070"
          sx={{
            fontSize: "24px",
            marginBottom: "25px",
          }}
        >
          <ArrowBackIcon
            sx={{
              fontSize: "24px",
              fontWeight: "bold",
              marginRight: "10px",
              cursor: "pointer",
            }}
            onClick={() => handleBack()}
          />
          {is_update ? "Update FAQ" : "Add FAQs"}
        </Text>
        
        <Grid container spacing={2}>
           {/* add new dropdown according to api data */}
           <Grid item xs={4}>
              <InputLabel id="content-label">Select Page Type *</InputLabel>
              <Select
                sx={{ height: "40px", fontSize: "16px" }}
                labelId="content-label"
                id="content_type"
                fullWidth
                onChange={formik.handleChange("content_type")}
                onBlur={formik.handleBlur("content_type")}
                value={formik?.values?.content_type}
                defaultValue={formik?.values?.content_type}
                error={formik.errors.content_type ? true : false}
              >
                {pageTypes?.map((cat) => (
                  <MenuItem sx={{ fontSize: "14px" }} value={cat.id}>
                    {cat.name}  
                  </MenuItem>
                ))}
              </Select>
              {formik.errors.category_id && (
                <Typography sx={{ color: "red" }}>
                  {formik.errors.category_id}
                </Typography>
              )}
            </Grid>
           {/* add new dropdown according to api data */}
           {formik?.values?.content_type!=='HOME_PAGE' && formik?.values?.content_type!=='TRIP_PLAN' && <Grid item xs={4}>
            <InputLabel id="categories-label">Categories *</InputLabel>
            <Select
              sx={{ height: "40px", fontSize: "16px" }}
              labelId="categories-label"
              id="categories"
              fullWidth
              onChange={formik.handleChange("category_id")}
              onBlur={formik.handleBlur("category_id")}
              value={formik?.values?.category_id}
              defaultValue={formik?.values?.category_id}
              error={formik.errors.category_id ? true : false}
              disabled={formik?.values?.content_type==='HOME_PAGE' || formik?.values?.content_type==='TRIP_PLAN'}
            >
              {ParentCategoriesList?.map((cat) => (
                <MenuItem sx={{ fontSize: "14px" }} value={cat.id}>
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
           { formik.errors.category_id && (
              <Typography sx={{ color: "red" }}>
                {formik.errors.category_id}
              </Typography>
            )}
          </Grid>}

         
        { formik?.values?.content_type!=='HOME_PAGE' && formik?.values?.content_type!=='TRIP_PLAN' && <Grid item xs={4}>
            <InputLabel id="sub-categories-label">Sub Categories</InputLabel>
            <Select
              sx={{ height: "40px", fontSize: "16px" }}
              labelId="sub-categories-label"
              id="sub-categories"
              fullWidth
              onChange={formik.handleChange("subcategory_id")}
              onBlur={formik.handleBlur("subcategory_id")}
              value={formik?.values?.subcategory_id}
              defaultValue={formik?.values?.subcategory_id}
              error={formik.errors.subcategory_id ? true : false}
              disabled={category.length > 0 && formik?.values?.content_type!=='HOME_PAGE' && formik?.values?.content_type!=='TRIP_PLAM' ? false :true}
            
            >
              {category?.map((cat) => (
                <MenuItem
                  sx={{ fontSize: "14px" }}
                  value={cat.id}
                  onClick={() => {}}
                >
                  {cat.name}
                </MenuItem>
              ))}
            </Select>
            {formik.errors.subcategory_id && (
              <Typography sx={{ color: "red" }}>
                {formik.errors.subcategory_id}
              </Typography>
            )}
          </Grid>}

          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              id="outlined-multiline-flexible"
              label="Question *"
              multiline
              onChange={formik.handleChange("question")}
              onBlur={formik.handleBlur("question")}
              value={formik?.values?.question}
              defaultValue={formik?.values?.question}
              error={formik.errors.question ? true : false}
              inputProps={{ style: { fontSize: "16px" } }}
            />

            {formik.errors.question && (
              <Typography sx={{ color: "red" }}>
                {formik.errors.question}
              </Typography>
            )}
          </Grid>

          <Grid item xs={12}>
            <TextField
              size="small"
              fullWidth
              id="outlined-multiline-flexible"
              label="Answer *"
              multiline
              onChange={formik.handleChange("answer")}
              onBlur={formik.handleBlur("answer")}
              value={formik?.values?.answer}
              defaultValue={formik?.values?.answer}
              error={formik.errors.answer ? true : false}
              inputProps={{ style: { fontSize: "16px" } }}
            />
            {formik.errors.answer && (
              <Typography sx={{ color: "red" }}>
                {formik.errors.answer}
              </Typography>
            )}
          </Grid>
          {is_update ? (
            <></>
          ) : (
            formik?.values?.content_type!=='HOME_PAGE' && formik?.values?.content_type!=='TRIP_PLAN' &&     <Grid item xs={12}>
              <Autocomplete
                size="small"
                multiple
                id="keywords"
                options={keywordsD.map((option) => option.title)}
                freeSolo
                renderTags={(value, getTagProps) =>
                  value.map((option, index) => (
                    <Chip
                      variant="outlined"
                      label={option}
                      {...getTagProps({ index })}
                    />
                  ))
                }
                renderInput={(params) => (
                  <TextField
                    size="small"
                    {...params}
                    variant="filled"
                    placeholder="Add Keywords"
                  />
                )}
                onChange={(event, value) => handleKeyword(value)}
              />
            </Grid>
          )}
        </Grid>
        <Grid container sx={{ mt: 1 }} spacing={2}>
          <Grid item xs={4.5}>
            <Button
              type="submit"
              disableElevation
              variant="contained"
              loading={loading}
            >
              {is_update ? `UPDATE Faq` : `ADD FAQ`}
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
};

const keywordsD = [];

export default AddFaq;
